export const BUSINESS_CARD_DESCRIPTION =
  "Instantly capture and verify contractor contact information from a business card. Our AI automatically extracts the name, title, company, email, and phone into a structured format to save you from manual data entry.";

export const BUSINESS_CARD_EXAMPLE_USE_CASES =
  "Automate contact entry, maintain accurate records, quickly digitize contractor info.";

export const BUSINESS_CARD_COST = "$1.99 per verification";

export const BUSINESS_CARD_INSTRUCTIONS = `### **Requirement guide for business card** 
Upload a digital copy of your business card. Make sure all information is legible and matches the verification requirements below.

**Upload business card:**

- **Prepare your file**
  - Have a clear digital copy ready.
  - Check that all text is legible.
  - Review the verification details below to confirm your business card meets the requirements.

- **Upload your file**
  - Upload your file on the next page.

**Accepted formats:**
  - Document (pdf)
  - Image (jpeg, png, webp, heic, heif)
  - Max 100MBs per file
`;

export const BUSINESS_CARD = {
  instructions: BUSINESS_CARD_INSTRUCTIONS,
  description: BUSINESS_CARD_DESCRIPTION,
  exampleUseCases: BUSINESS_CARD_EXAMPLE_USE_CASES,
  cost: BUSINESS_CARD_COST
};
